// Tipos TypeScript compartilhados para o cliente

// ============================================
// Modelos de Dados
// ============================================

export interface Book {
  id: number;
  title: string;
  description: string;
  publicationYear?: number;
  physicallyAvailable: boolean;
  isAwarded: boolean;
  createdAt: string;
  updatedAt: string;
  images?: BookImage[];
  tags?: Tag[];
}

export interface BookImage {
  id: number;
  bookId: number;
  filename: string;
  filepath: string;
  displayOrder: number;
  createdAt: string;
}

export interface TagCategory {
  id: number;
  name: string;
  displayName: string;
  createdAt: string;
  tags?: Tag[];
}

export interface Tag {
  id: number;
  categoryId: number;
  name: string;
  createdAt: string;
  category?: TagCategory;
  bookCount?: number;
}

// ============================================
// DTOs para criação/atualização
// ============================================

export interface CreateBookData {
  title: string;
  description: string;
  publicationYear?: number;
  physicallyAvailable?: boolean;
  isAwarded?: boolean;
  tagIds?: number[];
}

export interface UpdateBookData {
  title?: string;
  description?: string;
  publicationYear?: number;
  physicallyAvailable?: boolean;
  isAwarded?: boolean;
  tagIds?: number[];
}

export interface CreateTagData {
  categoryId: number;
  name: string;
}

// ============================================
// Filtros e Parâmetros de Busca
// ============================================

export interface BookFilters {
  tags?: number[];
  physicallyAvailable?: boolean;
  isAwarded?: boolean;
  category?: number;
  search?: string;
}

// ============================================
// Respostas da API
// ============================================

export interface ApiResponse<T = unknown> {
  success: boolean;
  data?: T;
  error?: ApiError;
}

export interface ApiError {
  code: string;
  message: string;
  fields?: Record<string, string>;
}

export interface PaginatedResponse<T> {
  success: boolean;
  data: T[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

// ============================================
// Importação WordPress
// ============================================

export interface ImportError {
  item: string;
  error: string;
  details?: string;
}

export interface ImportReport {
  success: boolean;
  totalProcessed: number;
  booksImported: number;
  imagesDownloaded: number;
  tagsCreated: number;
  errors: ImportError[];
  warnings: string[];
  startTime: string;
  endTime: string;
  duration: number;
}

export interface ImportStatus {
  importId?: string;
  status: 'processing' | 'completed' | 'error';
  progress: number;
  message?: string;
  report?: ImportReport;
}

// ============================================
// Validação
// ============================================

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================
// Categorias de Tags Pré-definidas
// ============================================

export const TAG_CATEGORIES = {
  PROCESS: 'process',
  PAPER: 'paper',
  FINISHING: 'finishing',
  TECHNOLOGY: 'technology',
  ENHANCEMENT: 'enhancement',
  WORK_TYPE: 'work_type',
} as const;

export const TAG_CATEGORY_DISPLAY_NAMES: Record<string, string> = {
  process: 'Processo',
  paper: 'Papéis',
  finishing: 'Acabamento',
  technology: 'Tecnologia',
  enhancement: 'Enobrecimento',
  work_type: 'Tipo de Obra',
};
